import React from 'react';
import { CurrencyInput, PercentInput } from '../../../utils/FormInputs';

/**
 * SectionValoresArt - Componente para los importes y comisiones técnicas de ART.
 * Unificado con los inputs atómicos reutilizables para garantizar la coherencia visual.
 */
const SectionValoresArt = ({ state, actions }) => {
    const { formData } = state;
    const { handleCurrencyChange, handlePercentChange, handleChange } = actions;

    return (
        <fieldset className="border border-green-200 rounded-xl p-6 bg-green-50/20 text-left shadow-sm animate-fade-in transition-all duration-300">
            <legend className="px-3 text-lg font-bold text-green-800 tracking-tight">Valores del Contrato</legend>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-2">
                
                {/* 1. PRIMA EMITIDA (Componente Atómico Moneda) */}
                <CurrencyInput 
                    label="Prima Emitida ($)"
                    value={formData.primaEmitida}
                    onChange={(e) => handleCurrencyChange(e, 'primaEmitida')}
                    focusColor="focus-within:border-green-400 focus-within:ring-1 focus-within:ring-green-100"
                />

                {/* 2. COMISIÓN TOTAL ACUERDO (Componente Atómico Porcentaje) */}
                <div>
                    <PercentInput 
                        label="Comisión Acuerdo (%)"
                        name="porcentajeComision"
                        value={formData.porcentajeComision}
                        onChange={handlePercentChange || handleChange}
                        placeholder="0,00"
                        focusColor="focus-within:border-green-400 focus-within:ring-1 focus-within:ring-green-100"
                        textColor="text-blue-700"
                    />
                    <p className="text-[10px] text-slate-400 mt-1.5 ml-1 uppercase font-bold tracking-tight">
                        Comisión pactada con la Compañía
                    </p>
                </div>

            </div>
        </fieldset>
    );
};

export default SectionValoresArt;